import { createFileRoute } from "@tanstack/react-router";
import AreasHub from "@/pages/AreasHub";
import { buildHead } from "@/lib/seo";

export const Route = createFileRoute("/areas/")({
  head: () =>
    buildHead({
      title:
        "Areas We Serve in Broward County, FL | Precision Pavers & Pool Design",
      description:
        "Proudly serving Fort Lauderdale, Coral Springs, Pembroke Pines, Weston, Miramar, Sunrise, and Davie. Pool remodeling, deck resurfacing, driveway pavers, and outdoor enhancements across all of Broward County. Free estimates.",
      path: "/areas",
      jsonLd: {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://precisionpaverspools.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: "Areas We Serve",
            item: "https://precisionpaverspools.com/areas",
          },
        ],
      },
    }),
  component: AreasHub,
});
